export * from './program-added';
export * from './program-updated';
export * from "./program-not-found";
export * from "./program-already-exists";


import { ProgramAddedMessageTemplateComponent } from './program-added';
import { ProgramUpdatedMessageTemplateComponent } from './program-updated';
import { ProgramAlreadyExistsMessageTemplateComponent } from "./program-already-exists";
import { ProgramNotFoundMessageTemplateComponent } from "./program-not-found";

export const ProgramMessageComponents = [
  ProgramAddedMessageTemplateComponent,
  ProgramUpdatedMessageTemplateComponent,
  ProgramNotFoundMessageTemplateComponent,
  ProgramAlreadyExistsMessageTemplateComponent,
];
